export const CHANGE_TAB = 'SIDEBAR/CHANGE_ACTIVE_TAB';
export const TOGGLE_COLLAPSE = 'SIDEBAR/TOGGLE_COLLAPSE_EXAPND';
export const COLLAPSE_SIDEBAR = 'SIDEBAR/COLLAPSE_NOW';
export const EXPAND_SIDEBAR = 'SIDEBAR/EXPAND_NOW';
export const TOGGLE_MOBILE_COLLAPSE = 'SIDEBAR/TOGGLE_MOBILE_COLLAPSE';
export const MOBILE_COLLAPSE_SIDEBAR = 'SIDEBAR/MOBILE_COLLAPSE_SIDEBAR';
export const MOBILE_EXPAND_SIDEBAR = 'SIDEBAR/MOBILE_EXPAND_SIDEBAR';
